import React, { useState } from 'react';
import './BGallery.css';
import BGalleryOne from '../../../assets/Gallery/galleryTwo.png';
import BGalleryTwo from '../../../assets/Gallery/placedOne.png';
import BGalleryThree from '../../../assets/Gallery/coursesImage.png';
import BGalleryFour from '../../../assets/Gallery/specializationImage.jpg';

function BGallery() {
    const [leftImage, setLeftImage] = useState({
        id: '1',
        src: BGalleryOne,
        alt: 'Bar 1',
        text: '100+ Students placed in hotel management',
    });

    const [rightImages, setRightImages] = useState([
        { id: '2', src: BGalleryTwo, alt: 'Bar 2', text: '50+ Students placed in airlines' },
        { id: '3', src: BGalleryThree, alt: 'Bar 3', text: '75+ Students placed in cruise management' },
        { id: '4', src: BGalleryFour, alt: 'Bar 4', text: '30+ Students placed in event management' },
    ]);

    const handleImageClick = (clickedImage) => {
        const newRightImages = rightImages.map(image =>
            image.id === clickedImage.id ? leftImage : image
        );
        setLeftImage(clickedImage);
        setRightImages(newRightImages);
    };

    return (
        <div className='bgallery-outer'>
            <div className="bgallery-inner">
                <div className="bgallery-left" style={{ backgroundImage: `url(${leftImage.src})` }}>
                    <h2 className="header-text">{leftImage.text}</h2>
                </div>
                <div className="bgallery-right">
                    {rightImages.map((image, index) => (
                        <div
                            key={image.id}
                            className="bgallery-image-container"
                            style={{ backgroundImage: `url(${image.src})` }}
                            onClick={() => handleImageClick(image)}
                        >
                        </div>
                    ))}
                </div>
            </div>
            <div className="bgallery-bottom">
                {[1, 2, 3, 4].map((id) => (
                    <div
                        key={id}
                        className={`indicator-circle ${leftImage.id === id.toString() ? 'active' : ''}`}
                    ></div>
                ))}
            </div>
        </div>
    );
}

export default BGallery;
